import { servicesQuery } from '@/services/api';
import type { UseTasksOptions } from '../types';
import { transformBackfill } from '../utils/task-transform';
import { isInvisible } from '../utils/task-types';

export function useTasks(options: UseTasksOptions) {
  const { workspaceId, continuation, limit, enabled = true, state, type } = options;

  const { data, isLoading, error, refetch } = servicesQuery.getBackfills.useQuery({
    queryKey: ['backfills', workspaceId, continuation, state, type],
    queryData: {
      params: { environment_id: workspaceId ?? 0 },
      query: {
        continuation: continuation ?? undefined,
        state: state ?? undefined,
        type: type ?? undefined,
      },
    },
    enabled: enabled && workspaceId != null && workspaceId > 0,
    select: (queryData) => {
      if (queryData?.body.backfills == null) {
        return {
          filteredTasks: [],
          body: queryData?.body,
        };
      }

      const transformed = queryData.body.backfills.map(transformBackfill);
      const filtered = transformed.filter((task) => !isInvisible(task));

      return {
        filteredTasks: filtered,
        body: queryData.body,
      };
    },
  });

  // Apply limit after select to avoid unnecessary refetches when limit changes
  const tasks = (limit != null && limit > 0 ? data?.filteredTasks.slice(0, limit) : data?.filteredTasks) ?? [];

  return {
    tasks,
    meta: data?.body.meta,
    isLoading,
    error: error as Error | null,
    refetch: async () => {
      await refetch();
    },
  };
}
